module.exports = __webpack_public_path__ + "static/media/black-and-white-buildings-city-2255.b0e86291.jpg";